import actions from "./actions"

const initialState = {
  customers: [],
  workspaces: []
};

export default function customerWorkspaceReducers(state = initialState, action:{payload:any, type: string}):any{
    switch (action.type){
        case actions.SET_CUSTOMER_BY_WORKSPACE_ID:
            return {...state, customers: action.payload};
        case actions.SET_WORKSPACE_BY_CUSTOMER_ID:
            return {...state, workspaces: action.payload};
        default:
            return state
    }
}